var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeInMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0193 31.3447C29.68 31.3447 29.3407 31.2148 29.0823 30.9564L19.293 21.167C18.7747 20.6489 18.7747 19.8112 19.293 19.293C19.8112 18.7747 20.6488 18.7747 21.1671 19.293L30.9564 29.0822C31.4745 29.6005 31.4745 30.4381 30.9564 30.9564C30.6979 31.2148 30.3585 31.3447 30.0193 31.3447Z",
    fill: "#18A7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5911 1C6.64606 1 1 6.64612 1 13.5911C1 20.5361 6.64613 26.1823 13.5911 26.1823C20.5361 26.1823 26.1823 20.5361 26.1823 13.5911C26.1823 6.64612 20.5362 1 13.5911 1ZM13.5911 20.2181C9.52219 20.2181 5.81112 17.6998 4.37969 13.949C4.28694 13.7237 4.28694 13.4586 4.37969 13.2333C5.81106 9.4825 9.52219 6.96425 13.5911 6.96425C17.6601 6.96425 21.3711 9.4825 22.8026 13.2333C22.8953 13.4586 22.8953 13.7237 22.8026 13.949C21.3712 17.6998 17.6601 20.2181 13.5911 20.2181Z",
    fill: "#18A7B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2773 13.3134C10.2773 11.4844 11.7618 10 13.5908 10C15.4199 10 16.9043 11.4844 16.9043 13.3134C16.9043 15.1426 15.4198 16.6269 13.5908 16.6269C11.7618 16.6269 10.2773 15.1425 10.2773 13.3134Z",
    fill: "#18A7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeInMagnifier);
export default __webpack_public_path__ + "static/media/eye-in-magnifier.e998f782c70b2ee2fc4f5b9529919e04.svg";
export { ForwardRef as ReactComponent };